import React, { useEffect, useState } from 'react';

import { ExperimentOutlined } from '@ant-design/icons';
import { PageHeader, Skeleton } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';

import * as S from './styled';

import {
  getSmartChargingSimulationChargeBoxes,
  getSmartChargingSimulationScenario,
} from '../../../hooks/smartcharging';
import { chargeBoxesWithKeys, SimScenario, withKeys } from '../../organisms/SmartChargingSimulator/scenario';
import { readSimulatorUrl } from '../../organisms/SmartChargingSimulator/simulatorUrl';
import { SmartChargingSimulator } from '../../organisms/SmartChargingSimulator/SmartChargingSimulator';

/**
 * Simulador de smart charging em página própria (MV2-2006). No modal não dava para rolar o
 * resultado; aqui a rolagem é a da página. Abre a partir do formulário do grupo, na mesma aba,
 * com o grupo (ou as estações escolhidas) e o limite do formulário na URL. Sem nada na URL,
 * abre no exemplo.
 */
const SmartChargingSimulatorPage = () => {
  const history = useHistory();
  const { search } = useLocation();
  const [loading, setLoading] = useState(true);
  const [initialScenario, setInitialScenario] = useState<SimScenario | null>(null);
  const [sourceLabel, setSourceLabel] = useState<string>();

  useEffect(() => {
    const { smartChargingId, chargeBoxIds, currentNominalA } = readSimulatorUrl(search);
    let active = true;

    (async () => {
      setLoading(true);

      try {
        let scenario: SimScenario | null = null;

        if (smartChargingId) {
          const { data } = await getSmartChargingSimulationScenario(smartChargingId);
          scenario = withKeys(data);
          setSourceLabel('Recarregar o grupo');
        } else if (chargeBoxIds.length) {
          const { data } = await getSmartChargingSimulationChargeBoxes(chargeBoxIds);
          scenario = { current_nominal_a: 0, meter: null, charge_boxes: chargeBoxesWithKeys(data) };
          setSourceLabel('Recarregar as estações');
        }

        // O limite que está no formulário vale mais que o gravado: a pessoa pode estar testando um valor
        if (scenario && currentNominalA) {
          scenario = { ...scenario, current_nominal_a: currentNominalA };
        }

        if (active) {
          setInitialScenario(scenario);
        }
      } catch {
        // Sem o grupo, o simulador abre no exemplo
        if (active) {
          setInitialScenario(null);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    })();

    return () => {
      active = false;
    };
  }, [search]);

  return (
    <S.Wrapper>
      <PageHeader
        style={{ width: '100%' }}
        // Aberta direto pelo endereço não tem para onde voltar: cai na lista de grupos
        onBack={() => (window.history.length > 1 ? history.goBack() : history.push('/virtual-groups'))}
        title={
          <S.Title>
            <ExperimentOutlined />
            Simulador de Smart Charging
          </S.Title>
        }
      />
      <S.Content>
        {loading ? (
          <Skeleton active paragraph={{ rows: 10 }} />
        ) : (
          <SmartChargingSimulator initialScenario={initialScenario} sourceLabel={sourceLabel} />
        )}
      </S.Content>
    </S.Wrapper>
  );
};

export default SmartChargingSimulatorPage;
